/* eslint-disable */
export default {
  callerCall: '発信者',
  transferCall: '転送',
} as const;

// @key: @#@"callerCall"@#@ @source: @#@"Caller"@#@
// @key: @#@"transferCall"@#@ @source: @#@"Transfer"@#@
